/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "information-fc4092ed--sprite",
  "use": "information-fc4092ed--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"information-fc4092ed--sprite\">\r\n  <defs>\r\n    <clipPath id=\"information-fc4092ed--sprite_clip-Login_Learn_More\">\r\n      <rect width=\"36\" height=\"36\" />\r\n    </clipPath>\r\n  </defs>\r\n  <g id=\"information-fc4092ed--sprite_Login_Learn_More\" data-name=\"Login_Learn More\" clip-path=\"url(#information-fc4092ed--sprite_clip-Login_Learn_More)\">\r\n    <rect id=\"information-fc4092ed--sprite_Rectangle_10690\" data-name=\"Rectangle 10690\" width=\"36\" height=\"36\" fill=\"none\" />\r\n    <g id=\"information-fc4092ed--sprite_Group_50\" data-name=\"Group 50\" transform=\"translate(16.5 11.25)\">\r\n      <g id=\"information-fc4092ed--sprite_exclamation-point\">\r\n        <g id=\"information-fc4092ed--sprite_Group_63\" data-name=\"Group 63\">\r\n          <path id=\"information-fc4092ed--sprite_Rectangle_64\" data-name=\"Rectangle 64\" d=\"M1553.944,1378.639h0a1.5,1.5,0,0,1,1.5,1.5v6a1.5,1.5,0,0,1-1.5,1.5h0a1.5,1.5,0,0,1-1.5-1.5v-6A1.5,1.5,0,0,1,1553.944,1378.639Z\" transform=\"translate(-1552.444 -1374.139)\" fill=\"currentColor\" />\r\n          <path id=\"information-fc4092ed--sprite_Rectangle_65\" data-name=\"Rectangle 65\" d=\"M1553.944,1372.639h0a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5h0a1.5,1.5,0,0,1-1.5-1.5h0A1.5,1.5,0,0,1,1553.944,1372.639Z\" transform=\"translate(-1552.444 -1372.639)\" fill=\"currentColor\" />\r\n        </g>\r\n      </g>\r\n    </g>\r\n  </g>\r\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
